<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  <path d="M35.44 1.18A9.36 9.36 0 0031.9.5c-3.9 0-6.65 2.17-6.67 5.28-.03 2.3 1.97 3.57 3.46 4.34 1.53.78 2.05 1.29 2.05 1.99-.01 1.07-1.23 1.56-2.37 1.56a7.57 7.57 0 01-3.7-.85l-.52-.26-.56 3.59c.93.44 2.64.83 4.4.85 4.15 0 6.85-2.14 6.88-5.45.02-1.82-1.04-3.22-3.31-4.35-1.39-.74-2.23-1.23-2.23-1.98.01-.68.71-1.37 2.27-1.37a6.46 6.46 0 012.94.61l.36.17.54-3.45zM21.12 16.76h-3.95L19.64.8h3.95l-2.47 15.97zM42.26 6.63L40.7 11.1h3.28l-.91-4.62-.28-1.37c-.11.35-.28.84-.4 1.16l-.12.36zM42.51.8h3.05l3.19 15.97h-3.66l-.47-2.4h-5.07l-.83 2.4h-4.14l5.86-14.65C40.84 1.08 41.56.8 42.51.8zm-28.63 0L10 11.69l-.42-2.22L8.2 2.13C7.98 1.11 7.28.83 6.4.8H.07L0 1.11a15.7 15.7 0 014.15 1.76l3.52 13.88h4.18L18.05.79h-4.17z" fill="#1E2A9F" fill-rule="evenodd"/>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyVisa2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 49 17',
    },
  },
};
</script>

<style scoped>
  
</style>